import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { USER_TYPE } from '../../data/common';
import { manualApi } from '../../api/global';
import { useRecoilState } from 'recoil';
import { userInfo } from '../../data/atom';
import Logo from '../../assets/images/img_logo_3.png';
import ManualsNavigation from '../../components/Manual/ManualsNavigation';
import MyManualList from '../../components/Manual/MyManualList';
import MyTestPaperList from '../../components/Manual/MyTestPaperList';
import TotalManualList from '../../components/Manual/TotalManualList';

const TABS = {
  MY: 'my',
  ALL: 'all',
};

function Manual() {
  const navigate = useNavigate();
  const [tab, setTab] = useState(TABS.MY);
  const [user, setUser] = useRecoilState(userInfo);
  const [myManuals, setMyManuals] = useState(null);
  const [totlaManuals, setTotalManuals] = useState([]);
  const [hoveredMyManual, setHoverededMyManual] = useState(null);
  const [selectedMyManual, setSelectedMyManual] = useState(null);
  const [loaded, setLoaded] = useState(false);

  // 유저정보
  useEffect(() => {
    // 쿠키 가져오기 함수
    const getCookie = name => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts?.length === 2) return parts.pop().split(';').shift();
      return null;
    };
    const userName = getCookie('user_name');
    const userGrade = Number(getCookie('user_grade'));
    if (!userName || !userGrade) {
      // window.location.href = 'https://cedubook.com/';
      return;
    }
    if (user?.type !== null || loaded) return;
    setUser({
      ...user,
      name: userName || null,
      type: userGrade || null,
    });
    setLoaded(true);
  }, [user, loaded, setUser, navigate]);

  // 나의교재 호출
  const loadMyManuals = useCallback(async () => {
    try {
      const { status, data } = await manualApi.getMyManuals();
      if (status === 200) {
        const allManuals = data.myBooks;
        allManuals?.sort((a, b) => {
          // 즐겨찾기(mb_favor)가 먼저 정렬
          if (a.mb_favor !== b.mb_favor) {
            return b.mb_favor - a.mb_favor;
          }
          // mb_favor: true는 favorited_at 기준
          if (a.mb_favor) {
            return new Date(b.favorited_at) - new Date(a.favorited_at);
          }
          // mb_favor: false는 added_at 기준
          return new Date(b.added_at) - new Date(a.added_at);
        });
        setMyManuals(allManuals);
        sessionStorage.setItem(
          'ceduMyManuals',
          JSON.stringify(allManuals?.length),
        );
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  // 전체교재 호출
  const loadTotalManuals = useCallback(
    async () => {
      try {
        const { status, data } = await manualApi.getAllManuals();
        if (status !== 200) return;
        const allManuals = data.books;
        allManuals?.sort((a, b) => {
          if (a.book_title < b.book_title) {
            return -1;
          }
          if (a.book_title > b.book_title) {
            return 1;
          }
          return 0;
        });
        setTotalManuals(allManuals);
        // 전체 교재 중 내 교재면 맨 앞 인덱스로
        // if (myManuals !== null && myManuals?.length > 0) {
        //   myManuals.forEach((myManual, myIndex) => {
        //     const target = allManuals.find(m => m.idx === myManual.book.idx);
        //     target.mybook_idx = myManual.idx;
        //     const targetIdx = allManuals.findIndex(
        //       m => m.idx === myManual.book.idx,
        //     );
        //     if (targetIdx !== -1) {
        //       allManuals.splice(targetIdx, 1);
        //     }
        //     allManuals.splice(myIndex, 0, target);
        //   });
        // }
        // // 내 교재가 아니면 book_title 가나다순 정렬
        // const listInMyManuals = allManuals.filter(manual => {
        //   const isFind =
        //     myManuals?.find(m => m.book.idx === manual.idx) === undefined
        //       ? false
        //       : true;
        //   return isFind;
        // });
        // const listNotInMyManuals = allManuals.filter(manual => {
        //   const isFind =
        //     myManuals?.find(m => m.book.idx === manual.idx) === undefined
        //       ? false
        //       : true;
        //   return !isFind;
        // });
        // listInMyManuals?.sort((a, b) => {
        //   if (a.book_title < b.book_title) {
        //     return -1;
        //   }
        //   if (a.book_title > b.book_title) {
        //     return 1;
        //   }
        //   return 0;
        // });
        // listNotInMyManuals?.sort((a, b) => {
        //   if (a.book_title < b.book_title) {
        //     return -1;
        //   }
        //   if (a.book_title > b.book_title) {
        //     return 1;
        //   }
        //   return 0;
        // });
        // setTotalManuals([...listInMyManuals, ...listNotInMyManuals]);
      } catch (error) {
        console.error(error);
      }
    },
    [
      // myManuals
    ],
  );

  // 나의 매뉴얼 로드
  useEffect(() => {
    (async () => {
      if (!user.type) return;
      await loadMyManuals();
    })();
  }, [user, loadMyManuals]);

  // 전체 매뉴얼 로드
  useEffect(() => {
    (async () => {
      if (!user.type || user.type === USER_TYPE.STUDENT) return;
      if (myManuals === null) return;
      await loadTotalManuals();
    })();
  }, [user, myManuals, loadTotalManuals]);

  // 탭 바뀔 때 초기화
  useEffect(() => {
    setHoverededMyManual(null);
  }, [tab]);

  const initSelectedMyManual = () => {
    setSelectedMyManual(null);
  };

  return (
    <div className="pageContainer">
      <header className="flex items-center w-full min-h-[68px] h-[68px] px-[30px] py-[10px]">
        <img
          src={Logo}
          alt="logo"
          style={{
            width: '253px',
            height: '26px',
          }}
        />
      </header>
      {user.type === USER_TYPE.TEACHER && (
        <ManualsNavigation
          tab={tab}
          setTab={setTab}
          myManualCount={myManuals === null ? 0 : myManuals?.length}
        />
      )}
      <div
        className="w-full grow overflow-hidden"
        style={{ border: '2px solid #D9E2EB', borderTop: 'none' }}
      >
        {tab === TABS.MY ? (
          <div className="w-full h-full flex justify-center items-start">
            <MyManualList
              userType={user.type}
              myManuals={myManuals === null ? [] : myManuals}
              hoveredMyManualIdx={hoveredMyManual?.idx}
              setHoverededMyManual={setHoverededMyManual}
              selectedMyManual={selectedMyManual}
              setSelectedMyManual={setSelectedMyManual}
              setMyManuals={setMyManuals}
              reload={() => {
                loadMyManuals();
                loadTotalManuals();
                initSelectedMyManual();
              }}
            />
            {selectedMyManual !== null && (
              <MyTestPaperList
                selectedMyManual={selectedMyManual}
                myManuals={myManuals === null ? [] : myManuals}
              />
            )}
          </div>
        ) : (
          <div className="w-full h-full flex justify-center items-start">
            <TotalManualList
              totlaManuals={totlaManuals}
              myManualsIdxs={
                myManuals === null
                  ? []
                  : myManuals?.map(m => ({
                      book_idx: m.book_idx,
                      myBook_idx: m.idx,
                    }))
              }
              setTotalManuals={setTotalManuals}
              reload={() => {
                loadMyManuals();
                loadTotalManuals();
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default Manual;
